import { Model } from '@vuex-orm/core';

export default class Widmung extends Model {
  static entity = 'widmung';
  /**
   * @param {import('@vuex-orm/core').Record} record
   */
  constructor(record) {
    super(record);
    /** @type {string} */
    this.id;
    /** @type {string} */
    this.name_de;
    /** @type {string} */
    this.name_en;
  }

  static fields() {
    return {
      id: this.string(''),
      name_de: this.string(''),
      name_en: this.string('')
    };
  }
}
